import React from 'react'

import cn from 'classnames'

import AppFlex from 'components/App/AppFlex'
import AppText from 'components/App/AppText'
import AppIcon from 'components/App/AppIcon'

import helper from './helper'

export type Props = {
  children?: React.ReactNode
  value?: string | number | null
  label?: string
  icon?: string
  size?: number | Array<number>
  large?: boolean
  small?: boolean
  danger?: boolean
  highlight?: boolean
  outlined?: boolean
  xl?: boolean
  xs?: boolean
  style?: React.CSSProperties
  onRemove?: (value: string | number | null) => void
}

const AppTag: React.FC<Props> = (props) => {
  const classes = [
    ...helper.init(props),
    helper.color(props),
    helper.outlined(props),
    helper.size(props),
  ]

  const styles = {
    ...(props.style ?? {}),
  }

  const handleRemove = (e?: MouseEvent) => {
    if (e) {
      e.stopPropagation()
    }

    if (props.onRemove) {
      props.onRemove(props.value ?? null)
    }
  }

  const displayText = props.label || props.children

  return (
    <AppFlex row center gap={1} className={cn(classes)} style={styles}>
      {props.icon ? (
        <AppIcon icon={props.icon} />
      ) : null}

      <AppText nowrap xs medium highlight={props.highlight && !props.danger} danger={props.danger}>{displayText}</AppText>

      {props.onRemove ? (
        <AppFlex center style={{ cursor: 'pointer' }} onClick={handleRemove}>
          <AppIcon icon="close" size={10} />
        </AppFlex>
      ) : null}
    </AppFlex>
  )
}

export default AppTag